import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import { mapTilerApiKey } from '../apiKey';
import { useState } from 'preact/compat';
function getDefaultBounds() {
    // Germany roughly in center
    const defaultBounds = window.innerWidth > 600
        ? [
            [27, 136],
            [66, -116],
        ]
        : [
            [32, 24],
            [63, -3],
        ];
    return defaultBounds;
}
export default function Map({ locations, bounds = getDefaultBounds() }) {
    const [mapVisible, setMapVisible] = useState(false);
    // Show map only after 1s to prevent render bug with incorrect map size
    useEffect(() => {
        const timerId = setTimeout(() => setMapVisible(true), 1000);
        return () => clearTimeout(timerId);
    }, []);
    return (_jsx("div", Object.assign({ className: "leaflet-wrapper" }, { children: mapVisible && (_jsxs(MapContainer, Object.assign({ scrollWheelZoom: false, bounds: bounds, tap: false, minZoom: 3 }, { children: [_jsx(TileLayer, { attribution: '<a href="https://www.maptiler.com/license/maps/" target="_blank">\u00A9 MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">\u00A9 OpenStreetMap contributors</a>', url: `https://api.maptiler.com/maps/bright/{z}/{x}/{y}.png?key=${mapTilerApiKey}`, tileSize: 512, zoomOffset: -1 }, void 0), _jsx(MarkerClusterGroup, { children: locations
                        .filter(({ geolocation }) => geolocation.lat || geolocation.lng)
                        .map((location) => {
                        const functionsLabel = getLabel(location.functions, zankFinderData.functions);
                        return (_jsx(Marker, Object.assign({ position: location.geolocation, keyboard: false }, { children: _jsxs(Popup, { children: [_jsx("a", Object.assign({ href: location.url }, { children: _jsx("strong", { dangerouslySetInnerHTML: { __html: location.title } }, void 0) }), void 0), _jsx("div", { children: functionsLabel }, void 0)] }, void 0) }), location.title));
                    }) }, locations), _jsx(MapController, { bounds: bounds }, void 0)] }), void 0)) }), void 0));
}
function MapController({ bounds }) {
    const map = useMap();
    useEffect(() => {
        map.fitBounds(bounds);
    }, [bounds, map]);
    return null;
}
function getLabel(termIds, terms) {
    return termIds
        .map((termId) => { var _a, _b; return (_b = (_a = terms.find(({ id }) => id === termId)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : ''; })
        .join(', ');
}
